import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { Base64 } from 'js-base64';

import { JurPerson } from '../../@core/data/jur-person';
import { NgSelectModule, NgOption, NgSelectConfig } from '@ng-select/ng-select';
import { FormControl, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RestService } from '../../@core/utils/rest.service';
import { bank } from '../../@core/data/bank';
import { TypedJSON } from 'typedjson';
import { Result } from '../../@core/data/result';
import { Event, Router } from '@angular/router';
import { CompleterService, CompleterData } from 'ng2-completer';
import { NbToastrService, NbDialogService } from '@nebular/theme';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import Swal from 'sweetalert2';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
});


interface AngSelectEvent {
  name: string;
  value: any;
}

interface FoodNode {
  text: string;
  id: string;
  metadata: any;
  children?: FoodNode[];
}
interface ExampleFlatNode {
  expandable: boolean;
  text: string;
  level: number;
}

// const TREE_DATA: FoodNode[] = [
//   {
//     text: 'Fruit',
//     children: [
//       {text: 'Apple'},
//       {text: 'Banana'},
//       {text: 'Fruit loops'},
//     ]
//   }, {
//     text: 'Vegetables',
//     children: [
//       {
//         text: 'Green',
//         children: [
//           {text: 'Broccoli'},
//           {text: 'Brussel sprouts'},
//         ]
//       }, {
//         text: 'Orange',
//         children: [
//           {text: 'Pumpkins'},
//           {text: 'Carrots'},
//         ]
//       },
//     ]
//   },
// ];

@Component({
  selector: 'ngx-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})


export class MainComponent implements OnInit {
  keyword = 'text';

  editMode: any;
  editMode1: any;
  editMode2: any;
  editMode4: any;
  editMode5: any;
  editMode6: any;
  data1: any;
  public index: number = 0;
  nameBank: string;
  dataService: CompleterData;
  kbeOld: string;
  selectedBankOld: string;
  ind: any;
  chief: any;
  token: any;
  private _transformer = (node: bank, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      text: node.metadata.nameRu.replace(/\s\(ИИК:\s[A-Z]{2}[A-Z0-9]{18}\)/, ''),
      bic: node.metadata.bic,
      bin: node.metadata.bin,
      iban: node.metadata.iban,
      level: level,

    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
    this._transformer, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor(
    private router: Router,
    public rest: RestService,
    private toastrService: NbToastrService,
    private config: NgSelectConfig,
    private completerService: CompleterService,
    public translate: TranslateService,
    private dialogService: NbDialogService
  ) {

  }
  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  public jurPerson: any;
  public banks: bank[];

  // public selectedBank: bank;
  public posts: string;

  events: AngSelectEvent[] = [];
  bic: string;
  bin: string;
  iban: string;
  KBE: string;
  PHONE: string;
  curUSD: any;
  isComplate: boolean = true;
  formControlValue = '';
  names = [];
  addressOld: string;
  address: string = '';
  email: string = '';
  emailOld: string = '';
  contact: string = '';
  contactOld: string = '';
  oked: string = '';
  oldOked: string = '';
  selectedBank: string = '';
  nameCompany = '';
  objectLang: any;
  findChoices(searchText: string) {
    return this.names.filter(item => item.toLowerCase().includes(searchText.toLowerCase()))
      .slice(0, 5);
  }

  getChoiceLabel(choice: string) {
    return `@${choice} `;
  }

  htmlEscape(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }


  htmlUnescape(str) {
    if (typeof str === "undefined") return str;
    return str
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  }
  ngOnInit() {

    try {


      if (!sessionStorage.getItem('jurPerson')) {
        Swal.fire({
          text: this.translate.instant('ALERTNOSERVICE'),
          type: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: "#008e54"
        })
        this.router.navigate(['/auth/login']);
      }
      else {
        this.rest.getJurPerson(sessionStorage.getItem('jurPerson')).subscribe((data: Result) => {
          if (data.code == '0') {

            let base64 = data.message.toString();
            let jsonString = Base64.decode(base64);
            let pers = JSON.parse(jsonString);
            this.jurPerson = pers;
            this.jurPerson.contact = pers.phone
            this.token = JSON.parse(sessionStorage.getItem('jurPerson')).token;
            this.KBE = isNaN(pers.IRS + pers.SECO) == true ? null : (pers.IRS + pers.SECO);
            this.address = pers.address;
            this.nameCompany = pers.NAME_JUR;
            this.ind = pers.IDN;
            this.chief = pers.CHIEF;
            this.email = pers.email;
            this.emailOld = pers.email;
            this.contact = pers.phone;
            this.contactOld = pers.phone;
            this.oked = pers.oked;
            this.oldOked = pers.oked
            this.nameBank = this.htmlUnescape(pers.BANK);
            this.selectedBank = this.htmlUnescape(pers.BANK);
            this.bic = pers.BANK_BIK;
            this.bin = pers.BANK_BIN;
            this.iban = pers.BANK_IBAN;
            let that = this;
            //this.banks = [];
            this.addressOld = pers.address;
            this.kbeOld = this.encrypt(this.KBE);
            this.selectedBankOld = this.encrypt(this.selectedBank);

          }
          if (data.code == '-4') {
            Swal.fire({
              text: data.message,
              type: 'warning',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
            })
            sessionStorage.setItem('jurPerson', '');
            sessionStorage.setItem('jurName', '');
            this.router.navigate(['/auth']);
          }
          if (data.code == '-1') {
            sessionStorage.setItem('errorMessage', data.message);
            sessionStorage.setItem('jurPerson', '');
            sessionStorage.setItem('jurName', '');
            console.error('error - 2 - ' + data.message);
            Swal.fire({
              text: this.translate.instant('ALERTNOSERVICE'),
              type: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
            })
          }

        }
        );

        this.rest.getBanksList().subscribe((data: string) => {
          let that = this;
          let b: bank[] = <bank[]>JSON.parse(JSON.stringify(data));
          // that.banks  = b.filter((d) => {
          //   return (d.metadata.iban !== "" && d.metadata.iban !== null) ;
          // });
          that.banks = b;
          this.dataSource.data = that.banks;

          //  for (let i = 0; i < that.banks.length; i++) {
          //   if (that.banks[i].metadata.bic == pers.BANK_BIK) {
          //     // that.iban = that.banks[i].metadata.iban ==''|| that.banks[i].metadata.iban == undefined ? this.iban: that.banks[i].metadata.iban ;
          //   }
          // }
        });
      }
    }
    catch (e) {
      console.error(e.message);
    }
  }
  // showToast(status) {
  //   this.index += 1;
  //   this.toastrService.show(

  //     `Изменения ёохранены`,
  //     {status })}

  showToast1(position: any, status: any) {
    this.toastrService.show(

      ' ',
      `${this.translate.instant('ALERTNCHANGESAVED')}`,
      { position, status });
  }


  onSelectBank(event: any) {

    try {

      this.selectedBank = event.text;
      this.bin = event.bin;
      this.bic = event.bic;
      this.iban = "";
      //this.iban= event.iban;
      this.isComplate = false;

    }
    catch (e) {
      console.log(e);
    }
  }


  value1: string;

  editOked() {
    this.value1 = '1';
    this.editMode6 = !this.editMode6;

  }

  saveOked(edit: string) {
    this.editMode6 = !this.editMode6;
    sessionStorage.setItem("changed", edit);
    this.oked = edit;
  }

  onClickedOutsideee1(e: Event) {
    if (this.value1 != '1')
      this.saveOked(this.jurPerson.oked);
    this.value1 = '';
  }

  editEmail() {
    this.value1 = '1';
    this.editMode5 = !this.editMode5;

  }

  saveEmail(edit: string) {
    this.editMode5 = !this.editMode5;
    sessionStorage.setItem("changed", edit);
    this.email = edit;
  }

  onClickedOutsideee(e: Event) {
    if (this.value1 != '1')
      this.saveEmail(this.jurPerson.email);
    this.value1 = '';
  }

  editContact() {
    this.value1 = '1';
    this.editMode4 = !this.editMode4;

  }

  saveContact(edit: string) {
    this.editMode4 = !this.editMode4;
    sessionStorage.setItem("changed", edit);
    this.contact = edit;
  }

  onClickedOutsidee(e: Event) {
    if (this.value1 != '1')
      this.saveContact(this.jurPerson.contact);
    this.value1 = '';
  }

  editAddress() {
    this.value1 = '1';
    this.editMode = !this.editMode;

  }


  saveAddress(edit: string) {

    this.editMode = !this.editMode;

    sessionStorage.setItem("changed", edit);
    this.address = edit;
  }


  onClickedOutside(e: Event) {
    if (this.value1 != '1')
      this.saveAddress(this.jurPerson.address);
    this.value1 = '';
  }


  inputBank() {
    this.dataService = this.completerService.local(this.banks, 'metadata.nameRu', 'metadata.nameRu');
  }

  editNumber(arg: string) {
    this.value1 = '2';
    this.editMode1 = !this.editMode1;
    arg = sessionStorage.getItem("changed");
  }
  saveNumber(edit: string) {
    this.editMode1 = !this.editMode1;
    sessionStorage.setItem("changed", edit);
    sessionStorage.setItem('phone', this.PHONE);
  }

  onClickedOutside1(e: Event) {
    if (this.value1 != '2')
      this.saveNumber(this.PHONE);
    this.value1 = '';
  }

  editKbe(arg: string) {
    this.value1 = '3';
    this.editMode2 = !this.editMode2;
    arg = sessionStorage.getItem("changed");
  }
  saveKbe(edit: string) {
    this.editMode2 = !this.editMode2;
    sessionStorage.setItem("changed", edit);
    sessionStorage.setItem("KBE", this.KBE);

  }

  onClickedOutside2(e: Event) {
    if (this.value1 != '3')
      this.saveKbe(this.KBE);
    this.value1 = '';
  }
  encrypt(hashStr): string {

    var hash = 0, i, chr;
    if (hashStr === null || hashStr === "" || typeof hashStr === "undefined") return '';
    if (hashStr.length === 0) return '';
    for (i = 0; i < hashStr.length; i++) {
      chr = hashStr.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash.toString();

  }
  sendJurPerson(): void {
    try {

      try {
        if (parseInt(this.KBE) >= 11 && parseInt(this.KBE) <= 29) {
          this.jurPerson.IRS = parseInt((parseInt(this.KBE) / 10).toString()).toString();
          this.jurPerson.SECO = (parseInt(this.KBE) - parseInt((parseInt(this.KBE) / 10).toString()) * 10).toString();
        }
        else {
          Toast.fire({
            type: 'error',
            title: `${this.translate.instant('ALERTCODESEND')} ${this.KBE == null ? '' : this.KBE}`
          });
          return;
        }
      }
      catch (err) {
        console.log(err);
      }
      let pp = {
        "jur_person": this.jurPerson.ID_JUR,
        "idn": this.jurPerson.IDN,
        "name_jur": this.jurPerson.NAME_JUR,
        "address": this.jurPerson.address,
        "chief": this.jurPerson.CHIEF,
        "email": this.jurPerson.email,
        "contacts": this.jurPerson.contact,
        "oked": this.jurPerson.oked,
        "mainbk": this.jurPerson.MAINBK == undefined ? '0' : this.jurPerson.MAINBK,
        "irs": this.jurPerson.IRS == undefined ? '0' : this.jurPerson.IRS,
        "seco": this.jurPerson.SECO == undefined ? '0' : this.jurPerson.SECO,
        "ctzn": this.jurPerson.CTZN == undefined ? '0' : this.jurPerson.CTZN,
        "bin": this.bin,
        "bic": this.bic,
        "iban": this.iban,
        "nameBank": this.htmlEscape(this.selectedBank),
        "token": this.token,
        "lang": this.jurPerson.language.toString(),
        "iin": this.jurPerson.iin,
      };

      console.log(pp)

      // {
      //   "jur_person": this.jurPerson.ID_JUR,
      //    "idn": this.jurPerson.IDN,
      //    "name_jur":workName,
      //    "address": sessionStorage.getItem("ADDRESS"),
      //    "chief": fio,
      //    "mainbk": this.jurPerson.MAINBK,
      //    "irs": this.jurPerson.IRS,
      //    "seco": this.jurPerson.SECO,
      //    "ctzn": this.jurPerson.CTZN,
      //    "bin": this.jurPerson.BANK_BIN,
      //    "bic": this.jurPerson.BANK_BIK,
      //    "iban": sessionStorage.getItem("BANK_IBAN"),
      //    "nameBank": this.jurPerson.BANK,
      //    "token": "sad",
      //    "lang": sessionStorage.getItem("LANGUAGE"),
      //    "iin": sessionStorage.getItem("IIN"),
      //    "email":this.jurPerson.email,
      //    "contacts":sessionStorage.getItem("CONTACT"),
      //    "oked": sessionStorage.getItem("OKED")
      //   }


      this.rest.saveJurPerson(JSON.stringify(pp)).subscribe((res: any) => {
        if (res.code == "0") {
          if (this.address != this.addressOld) {
            Toast.fire({
              type: 'success',
              title: `${this.translate.instant('ALERTNADDRESS')} ${this.jurPerson.NAME_JUR} ${this.translate.instant('ALERTNADDRESS2')}
              `
            });

            this.addressOld = this.address;


          }
          if (this.contact != this.contactOld) {
            Toast.fire({
              type: 'success',
              title: `${this.translate.instant('Contact details')} ${this.jurPerson.NAME_JUR} ${this.translate.instant('ALERTNADDRESS2')}
              `
            });
            this.contactOld = this.contact;
          }

          if (this.encrypt(this.KBE) != this.kbeOld) {
            Toast.fire({
              type: 'success',
              title: `${this.translate.instant('ALERTCODECHNAGED')} ${this.jurPerson.NAME_JUR} ${this.translate.instant('ALERTCODECHNAGED2')}
              `
            });
            this.kbeOld = this.encrypt(this.KBE);
          }

          if (this.email != this.emailOld) {
            Toast.fire({
              type: 'success',
              title: `${this.translate.instant('Email address')} ${this.jurPerson.NAME_JUR} ${this.translate.instant('ALERTCODECHNAGED2')}
              `
            });
            this.emailOld = this.email;
          }

          if (this.encrypt(this.selectedBank) != this.selectedBankOld) {
            Toast.fire({
              type: 'success',
              title: this.translate.instant('ALERTBANKSAVE'),
            });
            this.selectedBankOld = this.encrypt(this.selectedBank);
          }
          if (this.oked != this.oldOked) {
            Toast.fire({
              type: 'success',
              title: `${this.translate.instant('OKEDCODECHANGED')} ${this.translate.instant('ALERTCODECHNAGED2')}
              `,
            });
            this.oldOked = this.oked;
          }

        }
        if (res.code == "-1") {
          Swal.fire({
            type: 'error',
            text: res.message,
            confirmButtonText: 'OK',
            confirmButtonColor: "#008e54"
          });
        }
        // console.log('res'+ res);
      });


      sessionStorage.setItem('bicBank', this.bic);
      sessionStorage.setItem('binBank', this.bin);
      sessionStorage.setItem('ibanBank', this.iban);
      sessionStorage.setItem('nameBank', this.selectedBank);
      sessionStorage.setItem('KBE', this.KBE);
      sessionStorage.setItem('address', this.jurPerson.address);
      sessionStorage.setItem('email', this.jurPerson.email);
      sessionStorage.setItem('contact', this.jurPerson.contact);
      sessionStorage.setItem('oked', this.jurPerson.oked);
    }
    catch (e) {
      Swal.fire({
        text: this.translate.instant('ALERTNOSERVICE'),
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
      })
    }

  }

  handleEngInput(ev) {
    var patt = new RegExp("^[?-_-.a-zA-Z0-9 \s]+$");
    let p = /[^a-zA-Z0-9]+/g;
    var res = patt.test(ev.target.value);

    if (!res) {
      ev.target.value = ev.target.value.replace(p, '');
    }
  }


  checkInputIban() {
    try {
      if (this.selectedBank != '') {
        if (this.isValidIBANNumber(this.iban) == 1) {

          this.isComplate = false;
          return 'success'

        }
        else {

          this.isComplate = true;
          return 'danger'

        }
      }
      else {
        this.isComplate = true;

        return 'danger'
      }
    }
    catch (ex) { console.log(ex) }

  }

  open(dialog: TemplateRef<any>) {
    let hasScroll = true;
    this.dialogService.open(dialog, { hasScroll });
  }


  public isValidIBANNumber(input) {
    var CODE_LENGTHS = {
      AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
      CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
      FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
      HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
      LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
      MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
      RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
    };
    var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
      code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
      digits;
    // check syntax and length
    if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return false;
    }
    // rearrange country code and check digits, and convert chars to ints
    digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
      return (letter.charCodeAt(0) - 55).toString();
    });
    // final check
    return this.mod97(digits);
  }
  public mod97(string) {
    var checksum = string.slice(0, 2), fragment;
    for (var offset = 2; offset < string.length; offset += 7) {
      fragment = String(checksum) + string.substring(offset, offset + 7);
      checksum = parseInt(fragment, 10) % 97;
    }
    return checksum;
  }
}
